'use strict';

module.exports = require('./is-implemented')()
	? Object.keys
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/es5-ext/object/keys/index.js
 ** module id = 65
 ** module chunks = 2
 **/